// External
import { createSlice } from "@reduxjs/toolkit";

// Action Constants
import { updateMathces } from "../actions/matches";

// Initial State
const initialState = {
	matches: {},
};
// Answer Reducer
const matches = createSlice({
	name: "matches",
	initialState,
	reducers: {},
	extraReducers: {
		// Used with external action which is defined in other directory
		[updateMathces.type]: (state, action) => {
			const { matches } = action.payload;

			state.matches = matches;
			return state;
		},
	},
});
export default matches.reducer;
